import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["control", "onUpdated"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon, XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var SelectInput = function SelectInput(_ref) {
  var _value$value, _ref2, _value$label;

  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      options = _ref.options,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange,
      onOpen = _ref.onOpen,
      _ref$sortable = _ref.sortable,
      sortable = _ref$sortable === void 0 ? true : _ref$sortable,
      containerClassName = _ref.containerClassName,
      showCloseBtn = _ref.showCloseBtn;
  var focusClass = 'focus-within:border-black focus-within:ring-black focus:outline-none focus-visible:border-gray-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-500';
  var hasSelectedValue = value && value.value !== undefined;
  var sortedOptions = options || [];

  if (sortable) {
    sortedOptions = _toConsumableArray(sortedOptions).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }
  /**
   * methods
   */


  var closeAction = function closeAction(e) {
    e.stopPropagation();
    onChange === null || onChange === void 0 ? void 0 : onChange(null);
  };

  return /*#__PURE__*/_jsx(Listbox, {
    value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : null,
    disabled: !!disabled,
    onChange: onChange,
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx('relative', containerClassName),
      children: [/*#__PURE__*/_jsxs(Listbox.Button, {
        className: clsx('relative w-full cursor-pointer rounded-lg border border-gray-300 bg-white pl-4 pr-10 text-left sm:text-sm', className, focusClass, {
          'pb-1 pt-3 ': !!label,
          'py-2': !label,
          'border-red-500': error,
          'cursor-not-allowed opacity-50': disabled
        }),
        onClick: onOpen,
        children: [label && /*#__PURE__*/_jsx("label", {
          className: clsx("origin-0 -z-1 pointer-events-none absolute left-4 block text-gray-600 transition-all", {
            'top-4 text-base text-gray-400 text-opacity-60': !hasSelectedValue,
            'top-2 text-xs': hasSelectedValue
          }),
          children: label
        }), /*#__PURE__*/_jsx("div", {
          className: clsx('flex items-end', {
            'h-9': !!label
          }),
          children: /*#__PURE__*/_jsx("span", {
            className: clsx('numeric-font-fix truncate font-sans text-base font-medium text-gray-900', {
              hidden: label && !hasSelectedValue
            }),
            children: (_ref2 = (_value$label = value === null || value === void 0 ? void 0 : value.label) !== null && _value$label !== void 0 ? _value$label : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label) !== null && _ref2 !== void 0 ? _ref2 : 'Select an option'
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
          children: /*#__PURE__*/_jsx(ChevronDownIcon, {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          })
        }), Boolean(value === null || value === void 0 ? void 0 : value.value) && showCloseBtn && /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "absolute inset-y-0 right-8 flex cursor-pointer items-center",
          onClick: closeAction,
          children: /*#__PURE__*/_jsx(XIcon, {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          })
        })]
      }), error && /*#__PURE__*/_jsx("p", {
        className: "text-red-error mt-2 text-xs font-bold italic leading-3",
        children: errorMessage
      }), /*#__PURE__*/_jsx(Transition, {
        as: Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx(Listbox.Options, {
          className: "absolute z-50 mt-1 max-h-72 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm dark:bg-slate-500",
          children: sortedOptions.map(function (option) {
            return /*#__PURE__*/_jsx(Listbox.Option, {
              className: function className(_ref3) {
                var active = _ref3.active,
                    disabled = _ref3.disabled;
                return "hover:bg-brand-primary/70 relative mb-px flex cursor-pointer select-none items-center justify-between px-4 py-1 last:mb-0 hover:text-white ".concat(active ? 'bg-brand-primary text-white dark:bg-slate-500 dark:text-gray-200 hover:dark:bg-slate-700 ' : 'text-gray-900 dark:bg-slate-500 dark:text-gray-200', " ").concat(disabled ? 'cursor-not-allowed bg-black/5' : '');
              },
              value: option.value,
              disabled: option.disabled,
              children: function children(_ref4) {
                var selected = _ref4.selected,
                    disabled = _ref4.disabled;
                return /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx("span", {
                    className: "numeric-font-fix block truncate ".concat(selected || option.selected ? 'font-medium' : 'font-normal', " ").concat(disabled ? 'italic text-black/50' : ''),
                    children: option.label
                  })
                });
              }
            }, option.value);
          })
        })
      })]
    })
  });
};
export var SelectInputControlled = function SelectInputControlled(_ref5) {
  var control = _ref5.control,
      onUpdated = _ref5.onUpdated,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref6) {
      var _props$options;

      var _ref6$field = _ref6.field,
          value = _ref6$field.value,
          onChange = _ref6$field.onChange;
      var val = (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.find(function (v) {
        return v.value === value;
      });

      var handleOnChange = function handleOnChange(e) {
        onChange(e);
        onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated(e);
      };

      return /*#__PURE__*/_jsx(SelectInput, _objectSpread(_objectSpread({}, props), {}, {
        value: val,
        onChange: handleOnChange
      }));
    }
  }));
};